import React, { useEffect } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { useSelector } from 'react-redux';
import SideBarListStyles from '../../../styles/SideBarListStyle';
import ShowProgress from '../../ui/Backdrop';

const SidebarListRnp = ({ filterArray, handleListItemClick }) => {
  const classes = SideBarListStyles();
  const selectedType = useSelector((state) => state.rnpData.selectedType);
  const myRefs = filterArray?.reduce((acc, val) => {
    acc[val.id] = React.createRef();
    return acc;
  }, {});

  useEffect(() => {
    if (myRefs[selectedType]) {
      myRefs[selectedType].current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [selectedType, myRefs]);

  const renderListItem = (data) => {
    const isSelected = selectedType === data.name;

    return (
      <div key={data.id} className={isSelected ? classes.highlightItem : ''}>
        <ListItem
          button
          selected={isSelected}
          className={classes.listStyling}
          onClick={() => handleListItemClick(data.name)}
          ref={myRefs[data.id]}
        >
          <ListItemText
            primary={<p className={isSelected ? classes.listTextSelected : classes.listTextNonSelected}>{data.name}</p>}
            secondary={
              <div className={isSelected ? classes.listSubTextSelected : classes.listSubTextNonSelected}>
                <div className={classes.listSubTextJustify}>
                  <div>{`${data.issuerCount || 0} RNPs`}</div>
                </div>
              </div>
            }
          />
        </ListItem>
      </div>
    );
  };

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="secondary mailbox folder">
        {filterArray.map(renderListItem)}
      </List>
      <ShowProgress />
    </div>
  );
};

export default SidebarListRnp;
